import React, { useState, useEffect, useContext } from 'react';
import Form from 'react-bootstrap/Form';
import OrderLineUpsells from './OrderLineUpsells.jsx';
import { Context } from './StockManagerContext.jsx';
import { Badge, InputGroup } from 'react-bootstrap';
import { formatMoney } from './utils.js';

export default function OrderLine({ product, idx, order, setOrder, selectedUpsells, setSelectedUpsells, invalidReasons, setInvalidReasons }) {

    const [ upsellTotal, setUpsellTotal ] = useState(0);
    const [ editing, setEditing ] = useState(false);
    const { currentUser, upsellData } = useContext(Context);

    useEffect(() => {
        let currentlyValid = true;
        for (const category of Object.keys(productsByCategory)) {
            let categoryName = category.replace(/^\d+\.\s*/, '');
            if (categoryName.endsWith('*')) {
                const hasSelection = productsByCategory[category].some(
                    sku => selectedUpsells[sku] && selectedUpsells[sku]?.qty > 0
                );
                if (!hasSelection) {
                    currentlyValid = false;
                    break;
                }
            }
        }

        console.log('%cLine', 'background-color: green', `Order line ${idx} validity: ${currentlyValid}`, {invalidReasons});


        if ( !currentlyValid && !invalidReasons.includes('upsells')) {
            setInvalidReasons([...invalidReasons, 'upsells']);

        } else if (currentlyValid && invalidReasons.includes('upsells')) {
            setInvalidReasons(invalidReasons.filter(r => r !== 'upsells'));
        }

        // Always mark invalid lines as editing
        if (!editing && !currentlyValid) {
            setEditing(true);
        }

    }, [upsellData, selectedUpsells, invalidReasons, order ]);

    // Calculate line subtotal
    useEffect(() => {
        //const productsubtotal = parseFloat(product.price) || 0;

        const selectedUpsellSubtotal = Object.entries(selectedUpsells).reduce((upsellSum, [sku, {qty, discount, price}]) => {
                if (qty <= 0) {
                    return upsellSum;
                }

                return upsellSum + (price * qty) - discount;
            }, 0);

        //const subtotal = productsubtotal + selectedUpsellSubtotal;
        setUpsellTotal(selectedUpsellSubtotal);

    }, [order, selectedUpsells]);

    const { upsells, products } = upsellData;
    const availableUpsells = upsells?.[product.model] || false;

    const productsByCategory = availableUpsells ? availableUpsells?.reduce((acc, sku) => {
        const productDetails = products[sku];

        if (!productDetails) return acc;

        if (productDetails && productDetails['Hide for Usergroup?']) {
            let { userRole } = currentUser || {};
            const hideForUsergroup = productDetails['Hide for Usergroup?'].split(',').map(s => s.trim());
            if (hideForUsergroup.includes(userRole)) {
                return acc;
            }
        }

        if (productDetails['Order Category']) {
            const category = productDetails['Order Category'];
            if (!acc[category]) {
                acc[category] = [];
            }
            acc[category].push(sku);
        }
        return acc;
    }, {}) : {};


    const categories = Object.keys(productsByCategory).sort();

    return (
        <>
            <tr>
                <td>{product.sku}</td>
                <td>{product.accountingCode}</td>
                <td style={{ width: '100%' }}>
                    <strong>{product.name}</strong> <Badge variant="secondary" style={{ marginRight: 6 }}>{product.warehouseCode}</Badge>
                    { availableUpsells && !editing && <div><small>
                        {Object.entries(selectedUpsells)
                            .map(([sku, {qty}]) => (
                                <div key={sku}>
                                    + {qty}x {sku} - {upsellData.products[sku]?.['Product Name'] || 'Unknown'}
                                </div>
                            ))
                        }
                        <a href="#" onClick={e => {
                            e.preventDefault();
                            setEditing(true);
                        }}>Add accessories, delivery or service</a>
                    </small></div> }
                </td>
                <td style={{ minWidth: 100, textAlign: 'right' }}>
                    {product.enableQty ? (
                        <Form.Group>
                            <Form.Control
                                defaultValue={1}
                                type="number"
                                onChange={e => {
                                    order[idx].qty = parseInt(e.target.value);
                                    setOrder([...order]);
                                }}
                            />
                        </Form.Group>
                    ) : (
                        1
                    )}
                </td>

                {/* Price input */}
                <td style={{ textAlign: 'right', minWidth: 170 }}>

                    <InputGroup>
                        <InputGroup.Prepend>
                            <InputGroup.Text>$</InputGroup.Text>
                        </InputGroup.Prepend>
                        <Form.Control
                            value={product.price || ''} min={0}
                            style={{ minWidth: 80 }}
                            type="number"
                            onChange={e => {
                                const newPrice = parseFloat(e.target.value) || 0;
                                order[idx].price = newPrice;
                                setOrder([...order]);
                            }}
                        />
                    </InputGroup>

                </td>

                {/* Discount input */}
                <td style={{ textAlign: 'right', minWidth: 170 }}>

                    <InputGroup>
                        <InputGroup.Prepend>
                            <InputGroup.Text>$</InputGroup.Text>
                        </InputGroup.Prepend>
                        <Form.Control
                            value={product.discount || ''} min={0}
                            style={{ minWidth: 80 }}
                            type="number"
                            onChange={e => {
                                const newDiscount = parseFloat(e.target.value) || 0;
                                order[idx].discount = newDiscount;
                                setOrder([...order]);
                            }}
                        />
                    </InputGroup>
                </td>

                <td style={{ textAlign: 'right' }}>
                    <span>{formatMoney(product.price-(product.discount||0))}</span>
                    { !editing && upsellTotal > 0 && <>
                        <br />
                        <small>+{formatMoney(upsellTotal)}</small>
                    </>}
                </td>
            </tr>
            { editing &&
            <tr>
                <td colSpan={7} style={{background: '#737373'}}>
                    <OrderLineUpsells
                        idx={idx}
                        product={product}
                        categories={categories}
                        productsByCategory={productsByCategory}
                        selectedUpsells={selectedUpsells}
                        setSelectedUpsells={setSelectedUpsells}
                        upsellData={upsellData}
                        upsellTotal={upsellTotal}
                        setEditing={setEditing}
                    />
                </td>
            </tr>
            }
        </>
    );
}
